<template>
  <v-footer
    name="footer"
    color="primary"
    class="pt-6 pt-md-10 pb-0 px-0 d-flex flex-column"
  >
    <v-container max-width="1440px">
      <v-row class="px-4 w-100">
        <!-- <v-col
				cols="12"
				lg="4"
				order="1"
			> -->
        <!-- <v-img
					:aspect-ratio="2.88"
					max-width="300px"
					class="py-4"
					width="100%"
					src="/assets/brand/logo-negativo.svg"
				/> -->
        <!-- <router-link
					to="/"
					class="text-decoration-none"
				>
					<v-card-title class="">
						Tu apoyo VIP
					</v-card-title>
				</router-link> -->
        <!-- </v-col> -->
        <v-col cols="12" sm="7" md="5">
          <v-card-title class="text-h5 px-0">
            Sobre {{ companyInfo.name }}
          </v-card-title>
          <v-card-text class="text-body-1 px-0">
            {{ companyInfo.description }}
          </v-card-text>
          <v-row no-gutters>
            <v-btn
              v-for="(socialMedia, idx) in companyInfo.rrss"
              :key="idx"
              density="compact"
              variant="outlined"
              rounded
              size="36"
              class="mr-3 mb-3"
              :href="socialMedia.url"
              :aria-label="`Visítanos en ${socialMedia.name}`"
            >
              <v-icon size="24" density="compact" :icon="socialMedia.icon" />
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-card-title class="px-0 text-h5"> Secciones </v-card-title>
          <v-list
            density="compact"
            class="bg-transparent pr-4"
            aria-label="Información de contacto"
            role="list"
          >
            <v-list-item
              class="px-0 item-title--custom"
              link
              variant="plain"
              title="Soluciones"
              href="/#insights"
              aria-label="Soluciones"
            />
            <v-list-item
              class="px-0 item-title--custom"
              link
              variant="plain"
              title="Funcionalidad"
              href="/#functionalities"
              aria-label="Funcionalidad"
            />
            <v-list-item
              class="px-0 item-title--custom"
              link
              variant="plain"
              title="Sobre nosotros"
              href="/#about"
              aria-label="Sobre nosotros"
            />
            <v-list-item
              class="px-0 item-title--custom"
              link
              variant="plain"
              title="Contacto"
              href="/contacto"
              aria-label="Contacto"
            />
            <v-list-item
              class="px-0 item-title--custom"
              link
              variant="plain"
              title="Políticas de Privacidad"
              href="/privacy-policy"
              aria-label="Políticas de Privacidad"
            />
          </v-list>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-card-title class="px-0 text-h5"> Contacto </v-card-title>
          <v-list
            density="compact"
            class="bg-transparent pr-4"
            aria-label="Información de contacto"
            role="list"
          >
            <v-list-item
              v-if="companyInfo.email"
              class="px-0 item-title--custom"
              link
              variant="plain"
              prepend-icon="$mdiEmail"
              :title="companyInfo.email"
              :href="`mailto:${companyInfo.email}`"
              :aria-label="`Contactar al correo electrónico: ${companyInfo.email}`"
            />
            <v-list-item
              v-if="companyInfo.address"
              class="px-0 item-title--custom text-wrap"
              link
              variant="plain"
              prepend-icon="$mdiMapMarker"
              :title="companyInfo.address"
              :href="companyInfo.location"
              target="_blank"
              :aria-label="`Dirección: ${companyInfo.address}`"
            />
            <v-list-item
              class="px-0 item-title--custom"
              link
              variant="plain"
              prepend-icon="$mdiPhone"
              :title="companyInfo.tel"
              :href="`tel:${companyInfo.tel}`"
              :aria-label="`Llamar al teléfono: ${companyInfo.tel}`"
            />
          </v-list>
        </v-col>
      </v-row>
      <v-row no-gutters class="justify-center w-100 pa-6 text-caption">
        <span class="">
          Copyright@ {{ new Date().getFullYear() }}. Todos los derechos
          reservados
        </span>
      </v-row>
    </v-container>
  </v-footer>
  <!-- </v-container> -->
</template>

<script setup lang="ts">
import { useDisplay } from "vuetify";
import companyInfo from "~/data/companyInfo";
const { smAndUp, lgAndUp } = useDisplay();
const loading = ref(false);
const form = ref(true);
const email = ref("");

function submitEmail() {
  email.value = "";
  form.value = true;
  // ! Ingresa el llamado de tu funcion fetch al backend del formulario
}
</script>

<style lang="scss">
.item-title--custom {
  .v-list-item-title {
    white-space: initial;
  }
}
</style>
